"use client";

/**
 * Баннер, который виден ТОЛЬКО залогиненным юзерам.
 * Используется на публичных лендингах (/tarot, /horoscopo и т.д.), чтобы
 * подсказать «у вас есть персональная версия в кабинете».
 *
 * Гости не видят ничего — для них баннер не рендерится (никакого SSR-flash).
 * Использует UserSessionProvider — не вызывает auth() на сервере, ISR не ломается.
 */

import Link from "next/link";
import { ArrowRight, Sparkles } from "lucide-react";
import { useUserSession } from "@/components/providers/UserSessionProvider";

interface Props {
  href: string;
  title: string;
  /** Опциональный подзаголовок, ~5-10 слов */
  subtitle?: string;
  /** Класс для root — обычно margin-bottom */
  className?: string;
}

export function LoggedInBanner({ href, title, subtitle, className }: Props) {
  const { isLoggedIn } = useUserSession();
  if (!isLoggedIn) return null;

  return (
    <Link
      href={href}
      className={`flex items-center gap-3 rounded-2xl bg-gradient-to-r from-violet-50 to-indigo-50 border border-violet-200 p-4 hover:from-violet-100 hover:to-indigo-100 transition-colors ${className ?? ""}`}
    >
      <div className="w-10 h-10 rounded-xl bg-violet-100 flex items-center justify-center shrink-0">
        <Sparkles className="w-5 h-5 text-violet-600" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold text-violet-900">{title}</p>
        {subtitle && (
          <p className="text-xs text-violet-700 leading-snug mt-0.5">{subtitle}</p>
        )}
      </div>
      <ArrowRight className="w-4 h-4 text-violet-600 shrink-0" />
    </Link>
  );
}
